// Liste des pays proposee dans les formulaires d'invitation (public et admin),
// centralisee ici pour eviter toute duplication entre InvitationRegister et
// les outils d'invitation manuelle de l'admin.
export const COUNTRIES = [
  'Suisse',
  'France',
  'Belgique',
  'Luxembourg',
  'Allemagne',
  'Italie',
  'Espagne',
  'Royaume-Uni',
  'Pays-Bas',
  'Portugal',
  'Canada',
  'États-Unis',
  'Autre',
]
